var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "876px",
    height: "876px",
    viewBox: "0 0 876 876",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.000000, 358.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.0238179,3.97977433 C32.5047902,-7.81011412 4.50507837,7.48192939 0.483747659,38.1370398 C-3.5365857,68.7931506 17.9444214,103.201499 48.4634491,114.991387 C78.9814795,126.781276 106.694951,111.683296 111.295744,81.2582618 C116.353325,47.8132312 93.5428456,15.7696628 63.0238179,3.97977433",
    id: "Fill-47",
    fill: "#51DEA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3189668,56.1953745 L43.8027571,87.6774952 C45.304806,89.8791256 47.8218607,91.1261195 50.4906174,90.9898849 C53.159374,90.8536503 55.5357052,89.3580532 56.805211,87.0152162 L81.0845089,42.1970229 C83.0825833,38.5077508 81.7012971,33.9036186 77.99957,31.9128038 C74.2968448,29.9209946 69.6759236,31.2972622 67.6778493,34.9865344 L49.3528528,68.8134809 L34.9172147,47.6603279 C32.551862,44.1938042 27.8141702,43.2948549 24.3350058,45.6516136 C20.8558414,48.0083724 19.953614,52.7298453 22.3189668,56.1953745",
    id: "Fill-48",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.1e6fce2eae2a24d1d55d0a745a29bd0c.svg";
export { ForwardRef as ReactComponent };